var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgControlsSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId,
    stroke: "#ff5e00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    color: "#000000",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "controlsIconTitle"
  }, "Controllers") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "controlsIconTitle"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 18L17 6M12 18L12 6M7 18L7 6M5 8L9 8M10 16L14 16M15 12L19 12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlsSvgrepoCom);
export default __webpack_public_path__ + "static/media/controls-svgrepo-com.75e6db4780a3f516366c6520bad1952a.svg";
export { ForwardRef as ReactComponent };